export enum UpsertType {
    insert = 0,
    update = 1,
    nothing = 2
}
export namespace UpsertType{
    export function getName(value: UpsertType): string {
        switch (value) {
            case UpsertType.insert:
                return "insert";
            case UpsertType.update:
                return "update";
            case UpsertType.nothing:
                return "nothing";
        }
    }
}
